<mat-sidenav-container class="main-menu-container">

  <mat-sidenav mode="side" opened [class.collapsed]="sidenavCollapsed" class="main-menu-sidenav">
    <mat-toolbar>
      <button mat-icon-button (click)="sidenavCollapsed = !sidenavCollapsed">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="toolbar-title">Frakcio</span>
    </mat-toolbar>
    <mat-nav-list>

      <a mat-list-item routerLink="/" routerLinkActive [routerLinkActiveOptions]="{exact: true}" #homeLink="routerLinkActive" [activated]="homeLink.isActive">
        <mat-icon matListItemIcon>home</mat-icon>
        <span matListItemTitle>Home</span>
      </a>
      <a mat-list-item routerLink="/invitation" routerLinkActive #invLink="routerLinkActive" [activated]="invLink.isActive">
        <mat-icon matListItemIcon>email</mat-icon>
        <span matListItemTitle>Invitaciones</span>
      </a>
      <a mat-list-item routerLink="/register" routerLinkActive #preLink="routerLinkActive" [activated]="preLink.isActive">
        <mat-icon matListItemIcon>assignment</mat-icon>
        <span matListItemTitle>Registros</span>
      </a>
      <a mat-list-item routerLink="/lockers" routerLinkActive #lockersLink="routerLinkActive" [activated]="lockersLink.isActive">
        <mat-icon matListItemIcon>inventory_2</mat-icon>
        <span matListItemTitle>Paquetería</span>
      </a>
      <a mat-list-item (click)="logout()">
        <mat-icon matListItemIcon>logout</mat-icon>
        <span matListItemTitle>Cerrar Sesión</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="main-menu-content">
      <router-outlet />
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>

<button mat-fab class="fab-bottom-left" [style.left]="sidenavCollapsed ? '88px' : '324px'" (click)="openPrincipalWindow()">
  <mat-icon>manage_search</mat-icon>
</button>


